module.exports = __webpack_public_path__ + "static/media/colleges-icon-2.1fb06785.svg";